/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_File_Name_No_DotsInputs */



/**
* | output |
* | --- |
* | "File name cannot contain '..'" |
*
* @param {Spaces_File_Name_No_DotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_file_name_no_dots = /** @type {((inputs?: Spaces_File_Name_No_DotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_File_Name_No_DotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Dateiname darf '..' nicht enthalten")
	return /** @type {LocalizedString} */ ("File name cannot contain '..'")
});